import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ICollectionCreditsResponse } from '../collection-credits-response';
import { collectionCreditsResponseSchema } from '../collection-credits-response';

export async function getCollectionCreditsApi(
  collectionId: number,
): Promise<IValidatedResponse<ICollectionCreditsResponse>> {
  return getRequest<ICollectionCreditsResponse>({
    path: `/sys/collections/${collectionId}/credits/v1`,
    schema: collectionCreditsResponseSchema,
  });
}
